import { createContext, useContext } from "react";
import { BrowserRouter } from "react-router-dom";

const AppContext = createContext();

export function AppProvider({ children }) {
  return (
    <BrowserRouter>
      <AppContext.Provider value={{}}>{children}</AppContext.Provider>
    </BrowserRouter>
  );
}

export function useAppContext() {
  return useContext(AppContext);
}
